var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4073 2.8125C10.125 2.8125 8.99999 5.0625 8.99999 5.0625C8.99999 5.0625 7.87499 2.8125 5.59265 2.8125C3.73781 2.8125 2.26898 4.3643 2.24999 6.21598C2.21132 10.0596 5.2991 12.793 8.68359 15.0901C8.7769 15.1536 8.88714 15.1875 8.99999 15.1875C9.11285 15.1875 9.22309 15.1536 9.3164 15.0901C12.7005 12.793 15.7883 10.0596 15.75 6.21598C15.731 4.3643 14.2622 2.8125 12.4073 2.8125Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/HeartOutline.c95e975ca5055cae825e765ae84ff799.svg";
export { ForwardRef as ReactComponent };